import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface DictionarySearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export const DictionarySearch = ({
  searchTerm,
  onSearchChange,
}: DictionarySearchProps) => {
  return (
    <div className="relative max-w-xl mx-auto">
      <div className="absolute left-4 top-0 bottom-0 flex items-center pointer-events-none">
        <Search className="h-5 w-5 text-muted-foreground" />
      </div>
      <Input
        type="text"
        placeholder="Buscar termo ou definição..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-12 h-14 text-lg rounded-full border-border"
      />
    </div>
  );
};
